/**
 * Configuración centralizada de API
 * Maneja baseURL y agrega .php automáticamente
 */

import axios from 'axios';

// Base URL de la API
const API_BASE = '/backend/api/v1';

// Crear instancia de axios configurada
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar .php a las URLs
api.interceptors.request.use((config) => {
  // Si la URL no tiene extensión, agregar .php
  if (config.url && !config.url.includes('.php')) {
    // Separar query string si existe
    const [path, queryString] = config.url.split('?');
    
    // Agregar .php al path
    config.url = `${path}.php${queryString ? '?' + queryString : ''}`;
  }
  
  return config;
});

// Interceptor para manejar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si es 401, limpiar token y redirigir a login
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Endpoints de la API
export const endpoints = {
  // Auth
  auth: {
    login: '/auth/login',
    me: '/auth/me',
    refresh: '/auth/refresh'
  },
  // Vuelos
  vuelos: {
    list: '/vuelos/index',
    detalle: '/vuelos/detalle',
    create: '/vuelos/index',
    update: '/vuelos/update',
    cerrar: '/vuelos/cerrar',
    abrir: '/vuelos/abrir',
    delete: '/vuelos/delete'
  },
  // Pallets
  pallets: {
    list: '/pallets/index',
    create: '/pallets/index',
    update: '/pallets/update',
    delete: '/pallets/delete',
    peso: '/pallets/peso'
  },
  // Posiciones
  posiciones: {
    list: '/posiciones/index',
    grid: '/posiciones/grid'
  },
  // Usuarios
  usuarios: {
    list: '/usuarios/index',
    create: '/usuarios/index',
    update: '/usuarios/index',  // PUT al mismo endpoint
    delete: '/usuarios/index'   // DELETE al mismo endpoint
  },
  // Equipos
  equipos: '/equipos/index',
  // Rutas (Instancias de vuelo)
  rutas: {
    list: '/rutas/index',
    create: '/rutas/index',
    update: '/rutas/update',
    delete: '/rutas/delete'
  },
  // Oficina
  oficina: {
    agentes: '/oficina/agentes',
    clientes: '/oficina/clientes',
    shippers: '/oficina/shippers',
    consignatarios: '/oficina/consignatarios',
    clientesfact: '/oficina/clientesfact'
  },
  // Reservas
  reservas: '/reservas/index',
  // Facturación
  facturacion: '/facturacion/index',
  // Guias
  guias: {
    estaciones: '/guias/estaciones',
    rutas: '/guias/rutas',
    porAgente: '/guias/porAgente',
    manifiesto: '/guias/manifiesto'
  },
  // Reportes
  reportes: {
    resumen: '/reportes/resumen',
    vuelos: '/reportes/vuelos',
    destinos: '/reportes/destinos',
    dangerousGoods: '/reportes/dangerous-goods',
    productividad: '/reportes/productividad'
  },
  // Warehouse
  warehouse: {
    list: '/warehouse/index',
    reception: '/warehouse/reception',
    loading: '/warehouse/loading',
    stats: '/warehouse/stats',
    sequence: '/warehouse/sequence',
    search: '/warehouse/search',
    detail: '/warehouse/detail',
    merge: '/warehouse/merge',
    split: '/warehouse/split'
  },
  // Tracking
  tracking: {
    status: '/tracking/index',
    public: '/tracking/public'
  },
  // Estaciones (aeropuertos)
  estaciones: '/estaciones/index',
  // Bookings (reservas de capacidad)
  bookings: {
    list: '/bookings/index',
    capacity: '/bookings/capacity'
  },
  // Migración de BD
  migrate: '/migrate',
  // Permisos
  permisos: {
    list: '/permisos/index',
    byUser: (userId) => `/permisos/index?usuario=${userId}`,
    assign: (userId) => `/permisos/index?usuario=${userId}`,
    check: (codigo) => `/permisos/index?check=${encodeURIComponent(codigo)}`,
    me: '/permisos/index?me=1'
  }
};

export default api;

